module.exports = __webpack_public_path__ + "static/img/cont35 (10).e5f512c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (10).jpg
// module id = Gz7Q
// module chunks = 0